import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 650,
    tableLayout: 'fixed',
    '& .MuiTableCell-head': {
      backgroundColor: theme.palette.background.primary.main,
      color: 'white',
    },
    '& .MuiTableSortLabel-root': {
      color: 'white',
      '&:hover': {
        color: 'white',
      },
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: 'rgb(224, 224, 224)',
      },
    },
  },
  tableWrapper: {
    margin: theme.spacing(3, 0),
    borderTopWidth: 0.5,
    borderTopColor: theme.palette.grey[100],
    borderTopStyle: 'solid',
    overflow: 'visible',
  },
}));

export default useStyles;
